export class ActivityTypeListApiModel {
  public static anyType: ActivityTypeListApiModel = new ActivityTypeListApiModel().deserialize({
    Id: null,
    Name: 'Any',
    IsDefault: true,
    IconNumber: null
  });
  public static allTypes: ActivityTypeListApiModel = {
    Id: undefined,
    Name: 'All activity types',
    IsDefault: true,
    IconNumber: null
  };
  public static allTypesTitleCase: ActivityTypeListApiModel = {
    Id: undefined,
    Name: 'All Activity Types',
    IsDefault: true,
    IconNumber: null
  };
  public imgSrc?: string;

  constructor(
    public Id: string = null,
    public Name: string = null,
    public IsDefault: boolean = false,
    public IconNumber: number = null
  ) {}

  public deserialize?(data: Object): ActivityTypeListApiModel {
    Object.assign(this, data);

    this.imgSrc = `/assets/icons/ac-types/ac-type-${this.IconNumber}.svg`;

    return this;
  }
}
